import { useMutation } from '@tanstack/react-query';
import {
  postShareMatchResultsEmail,
  type ShareMatchResultsEmailRequest,
  type ShareMatchResultsEmailResponse,
} from '../api/match-api';

export function useShareMatchResultsEmailMutation() {
  return useMutation<
    ShareMatchResultsEmailResponse,
    unknown,
    ShareMatchResultsEmailRequest
  >({
    mutationFn: (body) => postShareMatchResultsEmail(body),
  });
}
